import { render, staticRenderFns } from "./Waveform.vue?vue&type=template&id=4749f21f&scoped=true&"
import script from "./Waveform.vue?vue&type=script&lang=js&"
export * from "./Waveform.vue?vue&type=script&lang=js&"
import style0 from "./Waveform.vue?vue&type=style&index=0&id=4749f21f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4749f21f",
  null
  
)

export default component.exports